<h1 mat-dialog-title class="w-100">
	<i class="fa-solid fa-credit-card"></i
	>{{ mode === OrganizationBankAccountMode.ADD ? 'Dodaj konto bankowe' : 'Edytuj konto bankowe' }}
</h1>
<mat-dialog-content class="mat-typography pb-1 min-h-[320px]">
	<mat-form-field class="w-100">
		<input matInput type="text" placeholder="Numer konta" [(ngModel)]="bankAccountData.number" required />
	</mat-form-field>
	<mat-form-field class="w-100">
		<mat-select
			placeholder="Waluta"
			[(ngModel)]="bankAccountData.currency"
			required
			[compareWith]="organizationContactComparison"
		>
			<mat-option [value]="item" *ngFor="let item of currencies">{{ item.name }}</mat-option>
		</mat-select>
	</mat-form-field>
	<div class="d-flex flex-row justify-content-between">
		<mat-form-field class="w-85">
			<input matInput type="text" placeholder="SWIFT" [(ngModel)]="bankAccountData.swift" />
		</mat-form-field>
	</div>

	<!-- Account type is hidden because all accounts are PLN.
	EURO was incorrectly set as the account kind instead of currency in the business configuration. -->

	<!-- <mat-form-field class="w-100 mx-1">
		<mat-select [(ngModel)]="bankAccountData.kind" placeholder="Rodzaj konta bankowego" required>
			<mat-option [value]="item.id" *ngFor="let item of accountKind">
				{{ item.name }}
			</mat-option>
		</mat-select>
	</mat-form-field> -->

	<div class="organization-bank-accounts organization-bank-accounts--checkbox mx-1 my-1">
		<mat-checkbox
			color="primary"
			class="main-account-checkbox"
			[(ngModel)]="bankAccountData.mainAccount"
			[disabled]="doesMainAccountExist"
			>Konto główne dla organizacji
		</mat-checkbox>
	</div>
	<div class="organization-bank-accounts organization-bank-accounts--slide-toggle mx-1 my-1">
		<mat-slide-toggle [(ngModel)]="bankAccountData.isActive"> Czy jest aktywne?</mat-slide-toggle>
	</div>
	<div class="organization-bank-accounts organization-bank-accounts--slide-toggle mx-1 my-1">
		<mat-slide-toggle [(ngModel)]="bankAccountData.fastAlior"> Czy jest FAST ALIOR?</mat-slide-toggle>
	</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-raised-button color="warn" mat-dialog-close class="organization-deny-button">Anuluj</button>
	<button
		mat-raised-button
		class="organization-save-button"
		color="primary"
		(click)="bankAccountSave(mode)"
		cdkFocusInitial
	>
		{{ mode === OrganizationBankAccountMode.ADD ? 'Dodaj konto bankowe' : 'Zapisz edycje konta' }}
	</button>
</mat-dialog-actions>
